import { useAppDispatch, useAppSelector } from "../../../stores/hooks/hooks.ts";
import {
  fetchCompanySettings,
  setCompanySettings,
} from "../../../stores/thunks/companyThunk.tsx";
import { useEffect, useMemo, useState } from "react";
import { CompanySettingsPage } from "./company/CompanySettingsPage.tsx";
import { CompanyMember } from "../../../stores/types/companyTypes.tsx";
import { clearErrorEditCompany } from "../../../stores/slice/companySlice.tsx";
import { fetchOrganizationsList } from "../../../stores/thunks/organizationsThunk.tsx";

export const CompanySettingsWrapperPage = () => {
  const dispatch = useAppDispatch();
  const [companyName, setCompanyName] = useState<string>("");
  const [isOpenEditCompanyName, setIsOpenEditCompanyName] = useState(false);

  const { companySettings, isLoadingSettings } = useAppSelector(
    (state) => state.company,
  );
  const organizationsList = useAppSelector(
    (state) => state.organizations.organizationsList,
  );
  const { brandList, isLoading: isLoadingBrands } = useAppSelector(
    (state) => state.brand,
  );
  const { companyUsers, isLoadingUsers } = useAppSelector(
    (state) => state.company,
  );

  useEffect(() => {
    if (!companySettings) {
      dispatch(fetchCompanySettings());
    }
    if (!organizationsList) {
      dispatch(fetchOrganizationsList());
    }
  }, [dispatch, companySettings, organizationsList]);

  useEffect(() => {
    if (companySettings) {
      setCompanyName(companySettings.name);
    }
    return () => {
      dispatch(clearErrorEditCompany());
    };
  }, [dispatch, companySettings]);

  const usersData: CompanyMember[] | null = useMemo(() => {
    if (!companyUsers) return null;
    const members = (companyUsers.company_members || []).map((m) => ({
      ...m,
    }));
    const invitations = (companyUsers.pending_invitations || []).map((i) => ({
      id: i.id,
      email: i.email,
      role: i.role,
      first_name: i.first_name,
      last_name: i.last_name,
      job_title: "",
      profile_picture: null,
      profile_is_active: false,
      user_is_active: false,
      invitation_email_sent: true,
      created_at: i.created_at || i.expires_at,
      updated_at: i.updated_at || i.expires_at,
    }));
    return [...members, ...invitations];
  }, [companyUsers]);

  const handleSubmit = () => {
    if (companyName && companyName !== companySettings?.name) {
      dispatch(
        setCompanySettings({
          body: { name: companyName },
          callback: () => {
            dispatch(fetchCompanySettings());
            setIsOpenEditCompanyName(false);
          },
        }),
      );
    }
  };

  return (
    <CompanySettingsPage
      handleSubmit={handleSubmit}
      companyName={companyName}
      setCompanyName={setCompanyName}
      brandList={brandList || undefined}
      isLoadingBrands={isLoadingBrands}
      companyUsers={usersData || undefined}
      isLoadingUsers={isLoadingUsers}
      isOpenEditCompanyName={isOpenEditCompanyName}
      setIsOpenEditCompanyName={setIsOpenEditCompanyName}
      companySettings={companySettings || undefined}
      isLoadingSettings={isLoadingSettings}
    />
  );
};
